import {
  REFRESH_USER_BALANCE_START,
  REFRESH_USER_BALANCE_SUCCESS,
  REFRESH_USER_BALANCE_FAILED,
} from 'constants/action-types/user/refreshUserBalance';
import notification from 'helpers/notificationHelper';
import { ERROR } from 'constants/notificationStatus';
import apiAction from 'helpers/apiAction';

export default (userId, fetchTransactions) => dispatch => {
  dispatch(
    apiAction({
      url: `/users/${userId}/wallet/refresh_balance`,
      method: 'PUT',
      API_REQUEST_START: REFRESH_USER_BALANCE_START,
      API_REQUEST_SUCCESS: REFRESH_USER_BALANCE_SUCCESS,
      API_REQUEST_FAILURE: REFRESH_USER_BALANCE_FAILED,
      callbackOnSuccess: ({ message }) => {
        notification({ message });
        if (fetchTransactions) fetchTransactions();
      },
      callbackOnFailure: ({ message }) => {
        dispatch({
          type: REFRESH_USER_BALANCE_FAILED,
          payload: message,
        });
        notification({ message, status: ERROR });
      },
      onEnd: () => false,
    }),
  );
};
